import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../../app.config';
import { Router } from "@angular/router";
import { tap } from 'rxjs/operators';
import { AppRoute } from '../app.routes';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  public appConfig: AppConfig;
  constructor(public router: Router) {
    this.appConfig = new AppConfig();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    request = request.clone({
      headers: request.headers.set(
        'Authorization', 'Bearer ' + this.appConfig.getToken()
      )
    });
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // do stuff with response if you want
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              const isAuthenticated = this.appConfig.isAuthenticated();
              if (!isAuthenticated) {
                this.appConfig.removeCurrentUser();
                this.router.navigate([AppRoute.loginAdmin]);
              } else {
                this.router.navigate([AppRoute.errorUnauthorized]);
              }
            } else if (err.status === 404) {
              this.router.navigate([AppRoute.errornotfound]);
            } else {
              this.router.navigate([AppRoute.errorinternal]);
            }
          }
        }
      )
    );
  }
}
